import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import { selectRegisteredCompanyName } from 'src/app/core/store/onboarding/reducers+selectors/create-account.selector';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() headerText = '';
  subscriptions: Subscription[] = [];

  constructor(private router: Router, private store: Store<IAppState>) {}

  ngOnInit(): void {
    if (!this.headerText) {
      const props$ = this.store.select(selectRegisteredCompanyName);
      this.subscriptions.push(
        props$.subscribe((props) => {
          if (props !== '') this.headerText = props;
        })
      );
    }
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }
}
